import React, {useState, useEffect} from "react";
import BookmarkCard from "./bookmakrCard"; // Ensure correct spelling here
import {debounce} from "lodash";
import "./BookmarksCardsStyle.css";
import {functions, httpsCallable} from "./firebaseConfig";

function AiBookmarks() {
    const [bookmarks, setBookmarks] = useState([]);
    const [page, setPage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [totalBookmarks, setTotalBookmarks] = useState(0);
    const [badgeVisibility, setBadgeVisibility] = useState("visible");


    const collectionId = 32680330;

    useEffect(() => {
        const fetchBookmarks = async () => {
            setIsLoading(true);
            const fetchBookmarksFn = httpsCallable(functions, 'fetchBookmarks');
            try {
                const result = await fetchBookmarksFn({collectionId, page});
                if (result.data.items) {
                    setBookmarks((prevBookmarks) => [...prevBookmarks, ...result.data.items]);
                    setTotalBookmarks(result.data.total);
                }
            } catch (error) {
                console.error("Failed to fetch bookmarks:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchBookmarks();
    }, [page]);

    useEffect(() => {
        const handleScroll = debounce(() => {
            const currentScrollPos = window.pageYOffset;
            const nearBottom = window.innerHeight + currentScrollPos >= document.documentElement.scrollHeight - 100; // 100px threshold

            if (nearBottom && !isLoading) {
                setPage((prevPage) => prevPage + 1);
            }
        }, 100);

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            handleScroll.cancel();
        };
    }, [isLoading]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setBadgeVisibility("faded");
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            <div className={`badge badge-lg ${badgeVisibility}`}
                 style={{position: 'fixed', top: '10px', right: '10px', transition: 'opacity 0.3s'}}
                 onMouseOver={() => setBadgeVisibility("visible")}
                 onMouseOut={() => setBadgeVisibility("faded")}>
                {totalBookmarks}
            </div>
            <div className="flex flex-wrap justify-center">
                {bookmarks.map((bookmark) => (
                    <BookmarkCard
                        key={bookmark._id}
                        title={bookmark.title}
                        tags={bookmark.tags.map((tag) => tag.name)}
                        imageUrl={bookmark.cover}
                        description={bookmark.excerpt}
                        link={bookmark.link}
                        created={bookmark.created}
                    />
                ))}
            </div>

        </div>
    );
}

export default AiBookmarks;
